import React from 'react'
import ServicesPage from '../ServicesPage/ServicesPage'

const Services = () => {
    return (
        <div>
            <ServicesPage imageSrc="images/img-3.jpg"/>
        </div>
    )
}

export default Services
